import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  InputBase,
  CardMedia,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseLandingsPages } from "./UseLandingsPages";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import DeleteRow from "../../components/DeleteRow";
import {
  rsGotoLast,
  rsProgress,
  rsActiveMenu,
  rsParentCom,
} from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { toMoney } from "../../util/Utils";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

export default function LandingPages() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { GetLandingPages, DeleteLandingPage } = UseLandingsPages();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Id", "Desc");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [articleRes, setArticleRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetLandingPages(search, myPc, true, (landingPages) => {
      if (msGotoLast) {
        setMsGotoLast(false);
        goToLastPage(landingPages.pageCondition.totalPage);
        return;
      }
      setArticleRes(landingPages);
    });
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/landingmanagment/addLandinPage", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 230,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "enName",
      headerName: "نام لاتین",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl" }}
          >
            {cellValues.row.enName}
          </Typography>
        );
      },
    },
    {
      field: "visit",
      headerName: "بازدید",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visit ? toMoney(cellValues.row.visit) : 0}
          </Typography>
        );
      },
    },
    {
      field: "like",
      headerName: "like",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.like ? toMoney(cellValues.row.like) : 0}
          </Typography>
        );
      },
    },
    {
      field: "dislike",
      headerName: "dislike",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.dislike ? toMoney(cellValues.row.dislike) : 0}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 150,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.faName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());
                  return navigate("/landingmanagment/editLandinPage", {
                    state: {
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="محتوا">
              <IconButton
                onClick={() => {
                  setMsParentCom({
                    backUrl: "/landingmanagment/landingComponents",
                    parentComs: "/landingmanagment",
                    landingPageID: cellValues.row.id,
                  });
                  setScrollTo(cellValues.api.getScrollPosition());
                  return navigate("/landingmanagment/landingComponents", {
                    state: {
                      myPc: myPc,
                      search: search,
                      landingId: cellValues.row.id,
                    },
                  });
                }}
              >
                <CardMedia
                  sx={{ width: "18px" }}
                  component="img"
                  image="/static/img/LandingPageContent.svg"
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="لینک">
              <IconButton
                onClick={() => window.open(cellValues.row.url, "_blank")}
              >
                <InsertLinkIcon sx={{ width: "20px" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/landingmanagment" }],
      }}
    >
      {articleRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={articleRes.pageCondition.pageCount}
          rows={articleRes.landing}
          paginationMode="server"
          page={articleRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            articleRes?.pageCondition.totalItemCount
              ? articleRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: articleRes?.pageCondition.totalItemCount
                ? articleRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"صفحه لندینگ"}
        callback={() => {
          setProgress(true);
          DeleteLandingPage(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
